<script>
export default {
  name: "subMain"
}
</script>

<template>
  <div>
      <router-view />
  </div>
</template>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/subMain/subMain.vue